import amplitude from 'amplitude-js'

const logEvent = (event) => {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {    
        console.log(event)
    } else {
        amplitude.getInstance().logEvent(event)
    }
}

export default logEvent;